import { render, staticRenderFns } from "./ActiveStatusList.vue?vue&type=template&id=40598f31&scoped=true"
import script from "./ActiveStatusList.vue?vue&type=script&lang=js"
export * from "./ActiveStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40598f31",
  null
  
)

export default component.exports